import { z } from 'zod';
import { CancellationReason } from '@mews-commander/data-access';
import { SchemaFormDefinition } from '@mews-commander/form';
import { CustomErrorParams, CustomErrorType, lt, MAX_INPUT_TEXT_LENGTH, Validation } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';

export const cancelReservationsFormSchema = z.object({
    cancellationReason: z.nativeEnum(CancellationReason).default(CancellationReason.InputError),
    details: Validation.String.Required.max(MAX_INPUT_TEXT_LENGTH).default(''),
    acknowledge: z
        .boolean()
        .default(false)
        .refine((val) => val === true, {
            params: {
                errorType: CustomErrorType.Other,
                textKey: TextKey.CancelReservationsMustBeCheckedError,
            } satisfies CustomErrorParams,
        }),
});

export type CancelReservationsFormValues = z.infer<typeof cancelReservationsFormSchema>;
export type CancelReservationsFormInputValues = z.input<typeof cancelReservationsFormSchema>;

export const cancelReservationsFormDefinition: SchemaFormDefinition<typeof cancelReservationsFormSchema> = {
    fields: {
        cancellationReason: {
            field: { type: 'enum', enumPrefix: 'CancellationReason' },
            label: lt('CancelReservationsConfirmation'),
            disabled: true,
        },
        details: {
            label: lt('DetailPlural'),
        },
        acknowledge: {
            label: lt('CancelReservationsConfirmation'),
            required: true,
        },
    },
};
